import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../redux/app/hooks';
import { RootState } from '../../redux/app/store';
import { ProductConstants } from '../../constants/ProductConstants';
import {
    guidanceCardContent,
    GuidanceCardProductContent,
} from '../../components/chat/guidance-card/GuidanceCardContent';
import { useMemo } from 'react';

export interface UseGuidanceCardResult {
    showCard: boolean | undefined;
    content: GuidanceCardProductContent | undefined;
}

export const useGuidanceCard = (): UseGuidanceCardResult => {
    const { i18n } = useTranslation();
    const { GuidanceCard } = useAppSelector((state: RootState) => state.app.serviceInfo.featureFlags);
    const { hostContext } = useAppSelector((state: RootState) => state.hostContext);

    return useMemo(() => {
        const product = hostContext.products?.[0];
        const currentLang = i18n.language.split('-')[0]; // Handle 'en-US', 'sv-SE' etc.
        const lang = Object.keys(guidanceCardContent).includes(currentLang) ? currentLang : 'sv'; // Default to Swedish if language not found

        const productContentMap = product ? guidanceCardContent[lang][product.name] : undefined;
        const content = productContentMap
            ? (productContentMap[hostContext.typeOfBusiness ?? ''] ?? productContentMap.default)
            : undefined;

        const showCard =
            GuidanceCard &&
            hostContext.country === 'SE' &&
            content &&
            !(
                product?.name === ProductConstants.EAccounting.ProductName &&
                product.variant === ProductConstants.EAccounting.Variants.invoicing
            );

        return { showCard: !!showCard, content };
    }, [GuidanceCard, hostContext, i18n.language]);
};
